const OrderStatusRejectedIcon = () => {
  return (
    <svg
      className="w-3.5 h-3.5 text-red-500 dark:text-red-400"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2 2l12 12M2 14L14 2"
      />
    </svg>
  );
};

export default OrderStatusRejectedIcon;
